import { ProductType } from '@shared/gql/document-nodes'

export const isProductAvailableInStore = (x: {
  inStoreSelection: boolean | null
  productType: ProductType | null
}): boolean => (x.productType === ProductType.Product ? !!x.inStoreSelection : true)
